import type {NoiseTextureNode} from "#material/cycles/types"
import type {TexNoiseDimensions, TexNoiseType} from "#material/nodes/texture/tex-noise/types"

export const cyclesDimensions = (dimensions?: TexNoiseDimensions): NoiseTextureNode["parameters"]["dimensions"] => {
    if (!dimensions) {
        return undefined
    }

    return dimensions
}

export const fromCyclesDimensions = (cyclesDimensions?: NoiseTextureNode["parameters"]["dimensions"]): TexNoiseDimensions | undefined => {
    if (!cyclesDimensions) {
        return undefined
    }
    return cyclesDimensions
}

export const cyclesType = (type?: TexNoiseType): NoiseTextureNode["parameters"]["type"] => {
    if (!type) {
        return undefined
    }

    switch (type) {
        case "MULTIFRACTAL":
            return "multifractal"
        case "RIDGED_MULTIFRACTAL":
            return "ridged_multifractal"
        case "HYBRID_MULTIFRACTAL":
            return "hybrid_multifractal"
        case "FBM":
            return "fBM"
        case "HETERO_TERRAIN":
            return "hetero_terrain"
    }
}

export const fromCyclesType = (cyclesType?: NoiseTextureNode["parameters"]["type"]): TexNoiseType | undefined => {
    if (!cyclesType) {
        return undefined
    }

    switch (cyclesType) {
        case "multifractal":
            return "MULTIFRACTAL"
        case "ridged_multifractal":
            return "RIDGED_MULTIFRACTAL"
        case "hybrid_multifractal":
            return "HYBRID_MULTIFRACTAL"
        case "fBM":
            return "FBM"
        case "hetero_terrain":
            return "HETERO_TERRAIN"
    }
}
